import { render, staticRenderFns } from "./APIDropdown.vue?vue&type=template&id=b5a18ab2&"
import script from "./APIDropdown.vue?vue&type=script&lang=js&"
export * from "./APIDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports